/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import useInfiniteScroll from 'src/hooks/useInfiniteScroll';
import { useTenantContext } from 'src/components/TenantProvider';
import ProductsQuery from 'src/queries/ProductsQuery';
import ProductGridLoadingState from 'src/components/ProductGridLoadingState';
import { Banner, Link } from '@shopify/polaris';
import BannerMessages from 'src/components/BannerMessages';
import ProductGrid from 'src/components/ProductGrid';
import styleConstants from 'src/styles/constants';
import { POLL_INTERVAL } from './constants';

const ProductGridContainer = () => {
  const { session } = useTenantContext();
  const { data, loading, error, stopPolling, allLoaded, refetch, fetchinMore } =
    useInfiniteScroll({
      sessionId: session.id,
      query: ProductsQuery,
      type: 'products',
      poolling: true,
      pollInterval: POLL_INTERVAL,
    });

  const hasProducts = data && data.products.items.length > 0;
  const flags = useFlags();

  useEffect(() => {
    if (hasProducts) {
      stopPolling();
    }
  }, [hasProducts, stopPolling]);

  if (error) {
    const errorMessage = error.message.replace('GraphQL error:', '').trim();
    return <BannerMessages message={errorMessage} />;
  }

  return (
    <>
      {flags.featureDowntimeBanner && (
        <Banner status="warning">
          <p>
            This service is currently unavailable due to some routine
            maintenance we’re performing to improve our systems.{' '}
            <Link
              url="https://status.thinkific.com/incidents/wqc25rly4tbl"
              external
            >
              Learn more
            </Link>
          </p>
        </Banner>
      )}

      {loading || !hasProducts ? (
        <ProductGridLoadingState />
      ) : (
        <ProductGrid
          handleListProductMutation={refetch}
          isFetching={fetchinMore}
          isFinishedLoading={allLoaded}
          products={data.products.items}
        />
      )}

      <style jsx>{`
        :global(.Polaris-Banner) {
          margin-bottom: ${styleConstants.spacing.four};
        }
      `}</style>
    </>
  );
};

export default ProductGridContainer;
